module.exports = __webpack_public_path__ + "4fe0f73cc919ba2b7a3c36e4540d725c.woff";